// 国际化配置
import zhCN from "@/locale/zh-CN.messages";
import esES from "@/locale/es-ES.messages";
import enUS from "@/locale/en-US.messages";

const localeValue = window.sessionStorage.getItem("locale");
let yunwei = null;
if (localeValue === "zh") {
  yunwei = zhCN.commonBase;
} else if (localeValue === "es") {
  yunwei = esES.commonBase;
} else {
  yunwei = enUS.commonBase;
}

yunwei = zhCN.commonBase;

const OprationType = () => {
  // 运营类型定义
  const option1 = [
    {
      text: yunwei.wz10, // '全部',
      value: "",
    },
    {
      text: yunwei.wz3, // '星充直营',
      value: "2",
    },
    {
      text: yunwei.wz4, // '加盟直营',
      value: "3",
    },
    {
      text: yunwei.wz5, // '联营',
      value: "1",
    },
    {
      text: yunwei.wz6, // '他营',
      value: "0",
    },
    {
      text: yunwei.wz7, // '人人电站',
      value: "5",
    },
  ];

  const option2 = [
    {
      text: yunwei.wz10, // '全部',
      value: "",
    },
    {
      text: yunwei.wz8, // '私桩',
      value: "0",
    },
    {
      text: yunwei.wz9, // '非私桩',
      value: "1",
    },
  ];

  const option3 = [
    {
      text: yunwei.wz10, // '全部',
      value: "",
    },
  ];

  const oprationType = {
    option1: option1,
    option2: option2,
    option3: option3,
  };
  return oprationType;
};

export default OprationType;



// WEBPACK FOOTER //
// ./src/AntD/utils/oprationType.js